<template>
	<loading v-show="isLoading" />
</template>

<script>
import WebStorage from '@/common/WebStorage';
import { searchPermissions, createNewAccount } from '@/components/helpers';

import { mapActions } from 'vuex';

import OidcService from '@/services/oidc.service';
import Loading from '@/components/Loading.vue';
import TokenService from '@/services/token.service';

export default {
	components: {
		Loading,
	},
	async created() {
		this.isLoading = true;
		await this.signinCallback();
	},

	data() {
		return {
			account: [],
			userId: {},
			dataPermission: [],
			listPermission: [],
			accountData: [],
			isLoading: false,
		};
	},
	computed: {
	},

	mounted() {
	},

	methods: {
		...mapActions('aliareAccount', ['getUserId', 'getUserAccountId', 'getPermissionFromUser', 'getAccountDataV2', 'getAccountTenantV2', 'getAccountTenant', 'getUserPermissionById']),
		...mapActions('auth', ['authenticateUser', 'getUserInfo', 'revokeTokens', 'logout', 'updateTokens']),

		parseJwt(token) {
			return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
		},

		async signinCallback() {
			if (this.$route.query.error) {
				console.error(this.$route.query.error);
				return;
			}
			await OidcService.signinRedirectCallback().then(async (result) => {
				TokenService.setTokens(result);
				const token = TokenService.getTokens();
				this.userId = this.parseJwt(token.access_token);
				WebStorage.setItem('tokenData', this.userId);

				this.updateTokens(token);
				this.$store.commit('auth/setUserInfo', { userInfo: result.profile });
				this.userId = { ...this.userId, ...result.profile };

				if(this.userId.Level === 'N2') {
					await this.getAccountId();

				} else {
					this.checkN1OrN0Permission();
				}
			}).catch((e) => {
				console.error(e);
				this.$router.push('/login');
			});
		},

		async verifyPermission() {
			try {
				const result = await searchPermissions(this.accountData[0].userId, this.accountData[0].tenantId);

				if (result) {
					WebStorage.setItem('tenantId', this.accountData[0].tenantId);

					let accountInfo = createNewAccount(this.accountData[0]);
					const response = await this.getAccountDataV2(this.accountData[0].tenantId);
					await this.getUserId(this.userId.sub).then((user) => {
						WebStorage.setItem('userInfo', user);
					});
					accountInfo = {
						...accountInfo,
						principalAdminUser: response.principalAdminUser,
						adminUsers: response.adminUsers,
					}

					WebStorage.setItem('accountInfo', JSON.stringify(accountInfo));
					WebStorage.setItem('accountName', this.accountData[0].accountName);
					WebStorage.setItem('cardOrganization', JSON.stringify(this.accountData));

					
					this.$analytics.login();


					this.$router.push({
						name: 'workspace',
					});
					return this.isLoading = false;
				} else {
					this.isLoading = false;
					this.logout();
	
					return this.$store.commit('activeAlert', {
						message: this.$locale.baseText('login.noPermission'),
						status: 'error',
					});
				}


			} catch (error) {
				console.error('Error verifying permissions:', error);
				this.isLoading = false;

				this.$store.commit('activeAlert', {
					message: error.notifications,
					status: 'error',
				});
			}
		},

		async getAccountId() {
			try {
				const resultUserAccount = await this.getUserAccountId({
					userId: this.userId.sub,
					tenantId: this.userId.Tenant,
				});

				this.accountData = resultUserAccount.data
					.filter(account => account.active && !account.blocked);

				if (this.accountData.length === 0) {
					this.isLoading = false;
					this.logout();
					this.$store.commit('activeAlert', {
						message: this.$locale.baseText('login.noPermission'),
						status: 'error',
					});
				} else if (this.accountData.length >= 2) {
					this.$router.push('/organizacao');
					this.isLoading = false;

					return;
				}
				this.verifyPermission();
			} catch (error) {
				console.error('Error fetching user account ID:', error);
			}
		},
		async checkN1OrN0Permission() {
			try {
				const response = await searchPermissions(this.userId.sub, this.userId.Tenant);

				if(response) {
					this.userId.hasPermission = true;
					WebStorage.setItem('tokenData', this.userId);
					this.$router.push('/organizacao');
					this.isLoading = false;
					return;
				}

				this.userId.hasPermission = false;
				WebStorage.setItem('tokenData', this.userId);
				this.getAccountId();
			} catch (error) {
				this.isLoading = false;

				this.logout();
				this.$store.commit('activeAlert', {
					message: this.$locale.baseText('login.noPermission'),
					status: 'error',
				});
			}
		},

	},
};
</script>

